export const zhCleanup = {
  common: {
    records: '条记录',
    detail: '详情',
    yes: '是',
    no: '否',
    enabled: '开启',
    disabled: '关闭',
    delete: '删除',
    refresh: '刷新',
  },
  overview: {
    operationsTitle: '快捷操作',
    managedInventory: '已管理资产',
    availableGrowth: '可扩展空间',
    activeRecords: '条有效记录',
    logicalDensity: '逻辑密度',
  },
  login: {
    operationsControl: '运维控制台',
    trustedInventory: '统一管理所有机房、机柜和设备资产。',
    multiSite: '多机房',
    multiSiteDesc: '统一机房运维',
    rackAware: '机柜感知',
    rackAwareDesc: '校验 U 位上架',
    readyToScale: '可规模化',
    readyToScaleDesc: '面向 IDC 架构',
    secureAccess: '安全访问',
    securityFootnote: 'JWT 保护 · RBAC 权限 · 操作可审计',
  },
  device: {
    editBasicInfo: '编辑信息',
    editBasicInfoTitle: '编辑设备基础信息',
    editBasicInfoDesc: '这里只维护库存台账：品牌、型号、SN、CPU、内存、硬盘、显卡等。显卡可以为空，不会触发装机、重启或任何 Agent 操作。',
    basicInfoSaved: '设备基础信息已保存',
    gpu: '显卡',
    optionalGpu: '可为空，例如：无 / NVIDIA A10 x1',
    basicSection: '基础信息',
    networkSection: '网络信息',
    bmcSection: 'BMC 管理',
    secondaryMac: '备用 MAC',
    publicIp: '公网 IP',
    privateIp: '内网 IP',
    gateway: '网关',
    netmask: '掩码',
    dnsServers: 'DNS',
    switchName: '交换机',
    bmcUsername: 'BMC 用户名',
    bmcType: 'BMC 类型',
    bmcStatus: 'BMC 状态',
    managementNote: '管理备注',
    managementNotePlaceholder: '只记录库存备注，不保存 BMC 密码。',
    adjustPlacement: '调整位置',
    adjustPlacementTitle: '调整服务器上架位置',
    adjustPlacementDesc: '只修改机房、机架、起始 U 位和高度；保存时后端会校验 U 位是否被其他设备占用。',
    placementSaved: '服务器位置已更新',
    placementConflictNotice: '如果所选 U 位已被占用，系统会拒绝保存；请先到机架详情查看 U 位占用。',
    rackCapacity: '机架容量',
    rackOccupancyMap: '机架 U 位占用图',
    currentServer: '当前服务器',
    targetRackPreview: '目标机架预览',
    targetPreview: '目标位置',
    occupiedUnits: '已占用',
    freeUnits: '空闲',
    unitConflict: 'U 位冲突',
    noRackSelected: '请先选择机架',
    reinstallConfirmTitle: '重装前确认',
    reinstallConfirmDesc: '请先核对目标服务器、MAC、BMC、系统镜像、模板和装机网络。当前仍然只创建安全预检查任务。',
    reinstallReadinessCard: '重装准备状态',
    reinstallReadinessCardDesc: '不用理解复杂流程，看这里就知道这台服务器还缺什么。',
    readinessBlocked: '还不能重装',
    readinessBlockedDesc: '红色项目需要先处理，否则不能进入重装准备。',
    readinessAttention: '基本可准备',
    readinessAttentionDesc: '关键资料已具备，黄色项目建议在真实装机前补齐。',
    readinessReady: '准备就绪',
    readinessReadyDesc: '库存、网卡、镜像和模板都已具备，可以进入重装安全预检查。',
    readyCount: '已就绪',
    warningCount: '需关注',
    blockedCount: '需处理',
    readyDetailInventory: '已关联自动发现结果，库存来源明确。',
    readyDetailMac: '目标 MAC 已存在，后续装机会用它做核对。',
    readyDetailBmc: 'BMC IP 已存在，后续可用于一次性网卡启动。',
    readyDetailAgent: 'Agent 在线，可接收后续预检查任务。',
    readyDetailOS: '已有可用系统镜像。',
    readyDetailTemplate: '已有可用装机模板。',
    readyDetailNetwork: '已有装机网络配置。',
    editInventoryInfo: '补录装机资料',
    editInventoryInfoTitle: '补录装机资料',
    editInventoryInfoDesc: '这里只保存库存资料：BMC IP、MAC、交换机端口。不会启动 DHCP/PXE，不会重启服务器，也不会擦盘。',
    bmcIp: 'BMC IP',
    nicToInstall: '装机网卡',
    nicMac: '网卡 MAC',
    switchPortHelp: '例如：CE01 Eth1/47 或 Rack-A01-Port47',
    saveInventoryInfoSuccess: '装机资料已保存',
    noDiscoveryCannotEdit: '这台服务器还没有关联自动发现结果，暂时不能补录装机资料。',
    networkTopology: '网络拓扑',
    networkTopologyDesc: '从机房到装机网卡的链路视图，方便核对 MAC、端口和 BMC。',
    topologyDatacenter: '机房',
    topologyDatacenterMeta: '所属区域 / 节点',
    topologyRack: '机柜 / U位',
    topologyRackMeta: '物理上架位置',
    topologyServer: '服务器',
    topologyInstallNic: '装机网卡 / MAC',
    topologySwitchPort: '交换机端口',
    topologySwitchPortMeta: '人工补录或自动发现',
    inventoryEyebrow: '库存管理',
    inventoryIntro: '服务器详情里可查看配置、硬盘、MAC、交换机端口，并直接发起系统重装。',
    inventoryStatDatacenters: '机房',
    inventoryStatDatacentersDesc: '当前纳管机房',
    inventoryStatRacks: '机柜',
    inventoryStatRacksDesc: '已录入机柜',
    inventoryStatDevices: '服务器',
    inventoryStatDevicesDesc: '库存服务器资产',
    inventoryStatRisks: '风险设备',
    inventoryStatRisksDesc: '缺资料或硬件异常',
    inventoryRiskTitle: '待处理提醒',
    inventoryRiskDesc: '先把缺资料、未上架和硬盘风险处理掉，库存才算干净。',
    inventoryRiskDevices: '台风险设备',
    inventoryRiskMissingMac: '缺 MAC',
    inventoryRiskMissingMacDesc: '影响装机 MAC 核对',
    inventoryRiskMissingBmc: '缺 BMC',
    inventoryRiskMissingBmcDesc: '影响远程电源和启动控制',
    inventoryRiskUnplaced: '未上架',
    inventoryRiskUnplacedDesc: '缺少机柜或 U 位',
    inventoryRiskDisk: '硬盘风险',
    inventoryRiskDiskDesc: '健康度低或状态异常',
    inventoryRiskReady: '可重装',
    inventoryRiskReadyDesc: '具备安全预检查资料',
    inventoryQuickTitle: '快捷入口',
    inventoryQuickDesc: '常用库存和装机入口集中在这里。',
    inventoryDatacenterTitle: '机房库存',
    inventoryDatacenterDesc: '按机房查看机柜、服务器、Agent 和风险概况。',
    quickDatacenters: '机房管理',
    quickDatacentersDesc: '维护机房资料和状态',
    quickRacks: '机柜管理',
    quickRacksDesc: '查看机柜和 U 位占用',
    quickDiscovery: '自动发现',
    quickDiscoveryDesc: '发现服务器硬件和网卡',
    quickStorage: '存储健康',
    quickStorageDesc: '查看 RAID / 硬盘健康',
    quickProvisioning: '自动装机',
    quickProvisioningDesc: '查看装机任务和模板',
    serverAssets: '服务器资产',
    serverDetail: '服务器详情',
    detailOperations: '服务器操作台',
    detailOperationsDesc: '常用动作集中在这里：先看库存状态，再做重装预检查、补录资料或调整位置。',
    actionReinstallDesc: '从这台服务器发起安全预检查',
    actionReinstallNeedDiscovery: '缺少自动发现记录，暂不能重装',
    actionInstallDataDesc: '补齐 BMC、MAC、交换机端口',
    actionBasicInfoDesc: '维护品牌、型号、SN、配置',
    actionPlacementDesc: '调整机房、机架和 U 位',
    actionProvisioningDesc: '查看装机任务和模板',
    reinstall: '系统重装',
    refreshDetail: '刷新详情',
    viewProvisioning: '查看自动装机模块',
    reinstallReadonlyNotice: '当前重装入口只创建安全预检查任务，不会真实启动 DHCP/PXE/IPMI。',
    detailAction: '详情',
    serverConfig: '服务器配置',
    hardwareProfile: '硬件画像',
    assetIdentity: '资产标签',
    serialNumber: '序列号',
    vendor: '厂商',
    model: '型号',
    lifecycle: '生命周期',
    unitPosition: 'U 位',
    cores: '核心数',
    memory: '内存',
    disks: '硬盘',
    nicSummary: '网卡',
    networkInfo: '网络信息 / MAC / 交换机端口',
    discoveryLinked: '已关联自动发现',
    discoveryMissing: '未关联自动发现',
    primaryMac: '主 MAC',
    switchPort: '交换机端口',
    discoveryStatus: '发现状态',
    nic: '网卡',
    speed: '速率',
    pxe: 'PXE',
    pxeUsable: '可装机',
    pxeNeedConfirm: '需确认',
    primaryNic: '主网卡',
    noNicInfo: '暂无网卡信息',
    storageHealthTitle: '存储 / RAID / 硬盘健康',
    totalCapacity: '总容量',
    totalWritten: '累计写入',
    averageHealth: '平均健康度',
    storageHealthy: '存储健康',
    storageWarning: '需要关注',
    storageCritical: '存在风险',
    storageNoData: '暂无采集数据',
    storageIssueCount: '异常硬盘',
    storageDiskMeta: '已采集物理硬盘',
    storageCapacityMeta: '按硬盘容量汇总',
    storageWrittenMeta: 'SMART / 采集写入量',
    storageRaidMeta: '逻辑卷 RAID 级别',
    raidController: 'RAID / 控制器',
    volume: '卷',
    capacity: '容量',
    diskCount: '硬盘数',
    noVolumeInfo: '暂无 RAID / 逻辑卷信息',
    slot: '槽位',
    written: '写入量',
    healthPercent: '健康度',
    noDiskInfo: '暂无硬盘信息',
    reinstallDialogTitle: '系统重装',
    reinstallSafetyNotice: '当前只会从库存创建装机安全预检查任务，不会启动 DHCP/TFTP/iPXE，不会重启服务器，不会擦盘。',
    server: '服务器',
    chooseNicMac: '选择网卡 / MAC',
    osImage: '系统镜像',
    pxeProfile: '装机模板',
    provisioningNetwork: '装机网络',
    bootMode: '启动模式',
    targetMac: '目标 MAC',
    pxeNic: '装机网卡',
    canUseDirectly: '可直接使用',
    needOneTimeBoot: '需要 BMC 设置一次性网卡启动',
    realExecution: '真实执行',
    createReinstallDryRun: '创建重装安全预检查任务',
    missingDiscoveryForReinstall: '这台服务器还没有关联自动发现网卡/MAC，先完善库存网络信息后再重装。',
    chooseServerNicFirst: '请先选择服务器网卡 / MAC',
    chooseOSProfileFirst: '请先选择系统镜像和装机模板',
    reinstallTaskCreated: '重装任务已创建，仅进入安全预检查准备，不会真实装机。',
    reinstallOverrideReason: '库存详情发起重装：该网卡未标记为默认装机网卡，真实执行前需要 BMC 设置一次性网卡启动。',
    startU: '起始 U 位',
    heightU: '高度（U）',
    reinstallFlowTitle: '重装前确认',
    reinstallFlowDesc: '按这 4 步确认，全部满足后只创建安全预检查任务。',
    stepInventory: '库存确认',
    stepInventoryReady: '服务器已录入库存，并关联自动发现结果。',
    stepInventoryMissing: '服务器缺少自动发现结果，不能继续。',
    stepMac: 'MAC 核对',
    stepMacReady: '目标 MAC 来自库存/自动发现记录。',
    stepMacMissing: '请先选择目标网卡和 MAC。',
    stepOS: '系统选择',
    stepOSReady: '系统镜像和装机模板已选择。',
    stepOSMissing: '请选择系统镜像和装机模板。',
    stepSafety: '安全预检查',
    stepSafetyReady: '只创建预检查任务，不启动 DHCP/PXE，不重启，不擦盘。',
    agentOnline: 'Agent 在线',
    agentOffline: 'Agent 不在线',
    selectedOs: '已选系统',
    selectedTemplate: '已选模板',
    selectedNetwork: '已选网络',
    noProvisioningNetwork: '未选择装机网络',
    safeMode: '安全模式',
    executionLocked: '真实执行已锁定',
    readinessTitle: '可重装条件',
    readinessDesc: '下面这些条件决定是否能顺利进入重装安全预检查；红色必须先补，黄色是真实装机前必须关注。',
    requirementDiscovery: '自动发现关联',
    requirementMac: '目标 MAC',
    requirementBmc: 'BMC IP',
    requirementAgent: 'Whale Agent',
    requirementOS: '系统镜像',
    requirementTemplate: '装机模板',
    requirementNetwork: '装机网络',
    requirementOk: '已满足',
    fixDiscovery: '去自动发现确认入库，或补齐服务器序列号关联。',
    fixMac: '在自动发现结果中选择正确网卡，或补录服务器 MAC。',
    fixBmc: '补录 BMC IP；真实装机前需要用它设置一次性网卡启动。',
    fixAgent: '检查对应机房 Whale Agent 是否在线。安全预检查可先准备，但真实装机必须在线。',
    fixOS: '去自动装机模块新增或启用系统镜像。',
    fixTemplate: '去自动装机模块新增或启用装机模板。',
    fixNetwork: '建议选择本机房装机网络；真实 DHCP/PXE 窗口需要它。',
    fixAction: '去处理',
  },
  error: {
    DATACENTER_IN_USE: '机房下还有机架、设备、Agent 或装机任务，不能删除。请先清空关联资源。',
    DATACENTER_NOT_FOUND: '机房不存在或已删除。',
    DATACENTER_OPERATION_FAILED: '机房操作失败，请稍后再试。',
    DATACENTER_CONFLICT: '机房编码已存在，请换一个编码。',
    RACK_IN_USE: '机架下还有服务器设备，不能删除。请先迁移或删除设备。',
    RACK_NOT_FOUND: '机架不存在或已删除。',
    RACK_DELETE_FAILED: '机架删除失败，请稍后再试。',
    RACK_OPERATION_FAILED: '机架操作失败，请稍后再试。',
    DEVICE_NOT_FOUND: '设备不存在或已删除。',
    DEVICE_OPERATION_FAILED: '设备操作失败，请稍后再试。',
  },
}

export const enCleanup = {
  common: {
    records: 'records',
    detail: 'Detail',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    delete: 'Delete',
    refresh: 'Refresh',
  },
  overview: {
    operationsTitle: 'Operations',
    managedInventory: 'Managed inventory',
    availableGrowth: 'Available growth',
    activeRecords: 'active records',
    logicalDensity: 'logical density',
  },
  login: {
    operationsControl: 'Operations control',
    trustedInventory: 'One trusted inventory for every facility, rack and device.',
    multiSite: 'Multi-site',
    multiSiteDesc: 'Unified facility operations',
    rackAware: 'Rack-aware',
    rackAwareDesc: 'Validated U-space placement',
    readyToScale: 'Ready to scale',
    readyToScaleDesc: 'Domain-led architecture',
    secureAccess: 'Secure access',
    securityFootnote: 'JWT protected · RBAC access · Auditable changes',
  },
  device: {
    editBasicInfo: 'Edit info',
    editBasicInfoTitle: 'Edit device basic info',
    editBasicInfoDesc: 'This only maintains inventory fields: brand, model, SN, CPU, memory, disks, GPU, and related details. GPU can be empty. No provisioning, reboot, or Agent action is triggered.',
    basicInfoSaved: 'Device basic info saved',
    gpu: 'GPU',
    optionalGpu: 'Optional, for example: none / NVIDIA A10 x1',
    basicSection: 'Basic info',
    networkSection: 'Network info',
    bmcSection: 'BMC management',
    secondaryMac: 'Secondary MAC',
    publicIp: 'Public IP',
    privateIp: 'Private IP',
    gateway: 'Gateway',
    netmask: 'Netmask',
    dnsServers: 'DNS',
    switchName: 'Switch',
    bmcUsername: 'BMC username',
    bmcType: 'BMC type',
    bmcStatus: 'BMC status',
    managementNote: 'Management note',
    managementNotePlaceholder: 'Inventory note only. Do not store BMC passwords here.',
    adjustPlacement: 'Adjust placement',
    adjustPlacementTitle: 'Adjust server rack placement',
    adjustPlacementDesc: 'Only datacenter, rack, start U and height are changed. The backend validates occupied rack units before saving.',
    placementSaved: 'Server placement updated',
    placementConflictNotice: 'If the selected rack units are occupied, the system rejects the change. Check rack detail for U-space occupancy first.',
    rackCapacity: 'Rack capacity',
    rackOccupancyMap: 'Rack U-space map',
    currentServer: 'Current server',
    targetRackPreview: 'Target rack preview',
    targetPreview: 'Target placement',
    occupiedUnits: 'Occupied',
    freeUnits: 'Free',
    unitConflict: 'U conflict',
    noRackSelected: 'Select a rack first',
    reinstallConfirmTitle: 'Confirm before reinstall',
    reinstallConfirmDesc: 'Check target server, MAC, BMC, OS image, template, and provisioning network first. This still only creates a safety precheck task.',
    reinstallReadinessCard: 'Reinstall readiness',
    reinstallReadinessCardDesc: 'You do not need to understand the full workflow. This shows what the server still needs.',
    readinessBlocked: 'Not ready',
    readinessBlockedDesc: 'Red items must be fixed before reinstall preparation.',
    readinessAttention: 'Mostly ready',
    readinessAttentionDesc: 'Core data is ready. Yellow items should be completed before real install.',
    readinessReady: 'Ready',
    readinessReadyDesc: 'Inventory, NIC, OS image, and install template are ready for the safety precheck.',
    readyCount: 'ready',
    warningCount: 'attention',
    blockedCount: 'blocked',
    readyDetailInventory: 'Discovery is linked and inventory source is clear.',
    readyDetailMac: 'Target MAC exists and will be used for install verification.',
    readyDetailBmc: 'BMC IP exists for future one-time NIC boot.',
    readyDetailAgent: 'Agent is online for future precheck tasks.',
    readyDetailOS: 'An OS image is available.',
    readyDetailTemplate: 'An install template is available.',
    readyDetailNetwork: 'A provisioning network is available.',
    inventoryEyebrow: 'Inventory',
    inventoryIntro: 'View server configuration, disks, MACs, switch ports, and start reinstall from the server detail page.',
    serverDetail: 'Server detail',
    reinstall: 'System reinstall',
    editInventoryInfo: 'Complete install data',
    editInventoryInfoTitle: 'Complete install data',
    editInventoryInfoDesc: 'This only saves inventory data: BMC IP, MAC, and switch port. It does not start DHCP/PXE, reboot the server, or wipe disks.',
    bmcIp: 'BMC IP',
    nicToInstall: 'Install NIC',
    nicMac: 'NIC MAC',
    switchPortHelp: 'Example: CE01 Eth1/47 or Rack-A01-Port47',
    saveInventoryInfoSuccess: 'Install data saved',
    noDiscoveryCannotEdit: 'This server has no linked Discovery result yet. Install data cannot be edited here.',
    networkTopology: 'Network topology',
    networkTopologyDesc: 'Facility-to-install-NIC path for checking MAC, switch port, and BMC.',
    topologyDatacenter: 'Datacenter',
    topologyDatacenterMeta: 'Region / site',
    topologyRack: 'Rack / U position',
    topologyRackMeta: 'Physical placement',
    topologyServer: 'Server',
    topologyInstallNic: 'Install NIC / MAC',
    topologySwitchPort: 'Switch port',
    topologySwitchPortMeta: 'Manual entry or Discovery',
    inventoryStatDatacenters: 'Datacenters',
    inventoryStatDatacentersDesc: 'Managed sites',
    inventoryStatRacks: 'Racks',
    inventoryStatRacksDesc: 'Recorded racks',
    inventoryStatDevices: 'Servers',
    inventoryStatDevicesDesc: 'Inventory assets',
    inventoryStatRisks: 'Risk devices',
    inventoryStatRisksDesc: 'Missing data or hardware risk',
    inventoryRiskTitle: 'Attention required',
    inventoryRiskDesc: 'Clean up missing data, placement, and disk health risks first.',
    inventoryRiskDevices: 'risk devices',
    inventoryRiskMissingMac: 'Missing MAC',
    inventoryRiskMissingMacDesc: 'Affects install MAC checks',
    inventoryRiskMissingBmc: 'Missing BMC',
    inventoryRiskMissingBmcDesc: 'Affects remote power and boot control',
    inventoryRiskUnplaced: 'Unplaced',
    inventoryRiskUnplacedDesc: 'Missing rack or U position',
    inventoryRiskDisk: 'Disk risk',
    inventoryRiskDiskDesc: 'Low health or abnormal status',
    inventoryRiskReady: 'Reinstall ready',
    inventoryRiskReadyDesc: 'Safety precheck data is ready',
    inventoryQuickTitle: 'Quick entries',
    inventoryQuickDesc: 'Common inventory and provisioning entries are grouped here.',
    inventoryDatacenterTitle: 'Datacenter inventory',
    inventoryDatacenterDesc: 'View rack, server, Agent, and risk summary by datacenter.',
    quickDatacenters: 'Datacenters',
    quickDatacentersDesc: 'Maintain datacenter data and status',
    quickRacks: 'Racks',
    quickRacksDesc: 'View racks and U occupancy',
    quickDiscovery: 'Discovery',
    quickDiscoveryDesc: 'Discover hardware and NICs',
    quickStorage: 'Storage health',
    quickStorageDesc: 'View RAID / disk health',
    quickProvisioning: 'Provisioning',
    quickProvisioningDesc: 'View install tasks and templates',
    serverAssets: 'Server assets',
    detailOperations: 'Server operations',
    detailOperationsDesc: 'Common actions are grouped here: check inventory first, then run reinstall precheck, complete data, or adjust placement.',
    actionReinstallDesc: 'Start safety precheck from this server',
    actionReinstallNeedDiscovery: 'Discovery record required before reinstall',
    actionInstallDataDesc: 'Complete BMC, MAC, and switch port',
    actionBasicInfoDesc: 'Maintain vendor, model, SN, config',
    actionPlacementDesc: 'Adjust datacenter, rack, and U position',
    actionProvisioningDesc: 'View install tasks and templates',
    refreshDetail: 'Refresh detail',
    viewProvisioning: 'View provisioning module',
    reinstallReadonlyNotice: 'This reinstall entry only creates a safety precheck task and does not start DHCP/PXE/IPMI.',
    detailAction: 'Detail',
    serverConfig: 'Server configuration',
    hardwareProfile: 'Hardware profile',
    assetIdentity: 'Asset label',
    serialNumber: 'Serial number',
    vendor: 'Vendor',
    model: 'Model',
    lifecycle: 'Lifecycle',
    unitPosition: 'U position',
    cores: 'Cores',
    memory: 'Memory',
    disks: 'Disks',
    nicSummary: 'NICs',
    networkInfo: 'Network / MAC / switch port',
    discoveryLinked: 'Discovery linked',
    discoveryMissing: 'Discovery missing',
    primaryMac: 'Primary MAC',
    switchPort: 'Switch port',
    discoveryStatus: 'Discovery status',
    nic: 'NIC',
    speed: 'Speed',
    pxe: 'PXE',
    pxeUsable: 'Installable',
    pxeNeedConfirm: 'Needs confirm',
    primaryNic: 'Primary NIC',
    noNicInfo: 'No NIC information',
    storageHealthTitle: 'Storage / RAID / disk health',
    totalCapacity: 'Total capacity',
    totalWritten: 'Total written',
    averageHealth: 'Average health',
    storageHealthy: 'Storage healthy',
    storageWarning: 'Needs attention',
    storageCritical: 'At risk',
    storageNoData: 'No collected data',
    storageIssueCount: 'Issue disks',
    storageDiskMeta: 'Collected physical disks',
    storageCapacityMeta: 'Summed physical capacity',
    storageWrittenMeta: 'SMART / collected writes',
    storageRaidMeta: 'Logical volume RAID level',
    raidController: 'RAID / controller',
    volume: 'Volume',
    capacity: 'Capacity',
    diskCount: 'Disk count',
    noVolumeInfo: 'No RAID / volume information',
    slot: 'Slot',
    written: 'Written',
    healthPercent: 'Health',
    noDiskInfo: 'No disk information',
    reinstallDialogTitle: 'System reinstall',
    reinstallSafetyNotice: 'This only creates a provisioning safety precheck task from inventory. It does not start DHCP/TFTP/iPXE, reboot the server, or wipe disks.',
    server: 'Server',
    chooseNicMac: 'Choose NIC / MAC',
    osImage: 'OS image',
    pxeProfile: 'Install template',
    provisioningNetwork: 'Provisioning network',
    bootMode: 'Boot mode',
    targetMac: 'Target MAC',
    pxeNic: 'Install NIC',
    canUseDirectly: 'Can use directly',
    needOneTimeBoot: 'Needs BMC one-time NIC boot',
    realExecution: 'Real execution',
    createReinstallDryRun: 'Create reinstall safety precheck task',
    missingDiscoveryForReinstall: 'This server has no linked Discovery NIC/MAC yet. Complete inventory network data before reinstall.',
    chooseServerNicFirst: 'Choose server NIC / MAC first',
    chooseOSProfileFirst: 'Choose OS image and install template first',
    reinstallTaskCreated: 'Reinstall task created for safety precheck only. No real install will run.',
    reinstallOverrideReason: 'Inventory detail reinstall: this NIC is not marked as default install NIC. Real execution requires BMC one-time NIC boot.',
    startU: 'Start U',
    heightU: 'Height (U)',
    reinstallFlowTitle: 'Pre-reinstall confirmation',
    reinstallFlowDesc: 'Confirm these 4 steps. When ready, the UI only creates a safety precheck task.',
    stepInventory: 'Inventory check',
    stepInventoryReady: 'Server is in inventory and linked to Discovery.',
    stepInventoryMissing: 'Server is missing Discovery data.',
    stepMac: 'MAC check',
    stepMacReady: 'Target MAC comes from inventory/Discovery.',
    stepMacMissing: 'Select the target NIC and MAC first.',
    stepOS: 'OS selection',
    stepOSReady: 'OS image and install template are selected.',
    stepOSMissing: 'Choose OS image and install template.',
    stepSafety: 'Safety precheck',
    stepSafetyReady: 'Only a precheck task is created. DHCP/PXE, reboot, and disk wipe remain disabled.',
    agentOnline: 'Agent online',
    agentOffline: 'Agent offline',
    selectedOs: 'Selected OS',
    selectedTemplate: 'Selected template',
    selectedNetwork: 'Selected network',
    noProvisioningNetwork: 'No provisioning network selected',
    safeMode: 'Safe mode',
    executionLocked: 'Real execution locked',
    readinessTitle: 'Reinstall readiness',
    readinessDesc: 'These checks explain what is ready and what still needs attention before reinstall precheck.',
    requirementDiscovery: 'Discovery link',
    requirementMac: 'Target MAC',
    requirementBmc: 'BMC IP',
    requirementAgent: 'Whale Agent',
    requirementOS: 'OS image',
    requirementTemplate: 'Install template',
    requirementNetwork: 'Provisioning network',
    requirementOk: 'Ready',
    fixDiscovery: 'Confirm the server from Discovery or link it by serial number.',
    fixMac: 'Select the correct NIC from Discovery or complete server MAC inventory.',
    fixBmc: 'Complete BMC IP. Real install needs it for one-time NIC boot.',
    fixAgent: 'Check the datacenter Whale Agent status. Precheck can be prepared, but real install needs an online Agent.',
    fixOS: 'Create or enable an OS image in Provisioning.',
    fixTemplate: 'Create or enable an install template in Provisioning.',
    fixNetwork: 'Select the datacenter provisioning network for future DHCP/PXE window.',
    fixAction: 'Fix now',
  },
  error: {
    DEVICE_NOT_FOUND: 'Device not found.',
    DEVICE_OPERATION_FAILED: 'Device operation failed. Please try again.',
  },
}
